import gql from "graphql-tag";

const gqlQuery = gql`
  query RoomTemplate($roomTemplateId: ID, $contractId: ID) {
    roomTemplate(roomTemplateId: $roomTemplateId, contractId: $contractId) {
      id
      codename
      description
      pathFile
      contractId
      creationDate
      file
      test
      type
    }
  }
`;

export default ({ roomTemplateId, customerId, contractId, hasAdminPrivileges, skip = false }) => ({
  query: gqlQuery,
  skip: skip || !roomTemplateId || !contractId || (!hasAdminPrivileges && !customerId),
  variables: { roomTemplateId, customerId, contractId },
});

